import { ConvertTypeEnum } from 'src/shared/enum';
import * as Yup from 'yup';

export interface IUnitConverterRequestResponse {
	sourceValue: number;
	sourceUnit: string;
	finalUnit: string;
	finalValue?: number;
}

export const GetUnitConverterFormInitialValues = () => {
	return {
		sourceValue: 1, 
		convertType: ConvertTypeEnum.Length,
		sourceUnit: '',
		finalValue: 0,
		finalUnit: ''
	};
};

export const GetUnitConverterFormValidationSchema = (t: any) => {
    return Yup.object().shape({
		sourceValue: Yup.number().min(0, t('message-source-or-final-min-value')).max(10000000000,t('message-source-or-final-max-value')),
		finalValue: Yup.number().min(0,t('message-source-or-final-min-value')).max(10000000000,t('message-source-or-final-max-value'))
    });
}